import LocaleStrings from "Languages";

export default function () {
  return [
    {
      iconName: "appbranding",
      title: LocaleStrings.branding_app_branding_tab,
      description: "",
    },
    // {
    //   iconName: "webbranding",
    //   title: LocaleStrings.branding_web_branding_tab,
    //   description: "",
    // },
    {
      iconName: "appmenu",
      title: LocaleStrings.branding_app_menu_tab,
      description: "",
    },
    {
      iconName: "splash",
      title: LocaleStrings.branding_splash_tab,
      description: "",
    },
  ];
}
